import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { SectionLabel, Reveal } from '../components/Section';
import { CollaboratorCard } from './About';
import EnquiryForm from '../components/EnquiryForm';

export default function Collaborations() {
  const [collabs, setCollabs] = useState(null);

  useEffect(() => {
    api
      .collaborators()
      .then((d) => setCollabs(d.collaborators || []))
      .catch(() => setCollabs([]));
  }, []);

  return (
    <main className="min-h-screen" data-testid="collaborations-page">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-24">
        <SectionLabel testid="collaborations-label">Our Collaborators</SectionLabel>
        <Reveal>
          <h1 className="mt-5 font-display text-white text-4xl sm:text-6xl max-w-3xl">
            The organisers behind <span className="text-[#e8173a]">the arena</span>
          </h1>
        </Reveal>

        {collabs === null ? (
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="h-24 rounded-xl bg-[#1a1f2e] animate-pulse" data-testid={`collab-skeleton-${i}`} />
            ))}
          </div>
        ) : collabs.length > 0 ? (
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {collabs.map((c, i) => (
              <CollaboratorCard key={c.username || c.name || i} c={c} index={i} />
            ))}
          </div>
        ) : (
          <Reveal>
            <div className="mt-12 card-surface p-10 text-center max-w-2xl" data-testid="collaborators-empty">
              <p className="text-white font-bold">Our first collaborator line-up is being finalised</p>
              <p className="mt-2 text-sm text-[#8a8a8a]">
                Tournament organisers and host admins will appear here. Want to run tournaments on KROY? Send us an enquiry below.
              </p>
            </div>
          </Reveal>
        )}

        <div className="mt-20 grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          <Reveal>
            <div>
              <h2 className="font-display text-white text-3xl sm:text-4xl">
                Partner with <span className="text-[#e8173a]">KROY</span>
              </h2>
              <p className="mt-4 text-sm text-[#9e9e9e] leading-relaxed max-w-md">
                Sponsors, organisers, creators and esports organisations — if you want to host tournaments, sponsor prize
                pools or collaborate on events, drop us a message and the KROY team will get back to you.
              </p>
              <ul className="mt-6 space-y-3 text-sm text-[#c9c9c9]">
                <li className="flex items-center gap-3"><span className="w-1.5 h-1.5 rounded-full bg-[#e8173a]" />Host your own branded tournaments</li>
                <li className="flex items-center gap-3"><span className="w-1.5 h-1.5 rounded-full bg-[#e8173a]" />Sponsor prize pools and seasons</li>
                <li className="flex items-center gap-3"><span className="w-1.5 h-1.5 rounded-full bg-[#e8173a]" />Creator and streamer partnerships</li>
              </ul>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <EnquiryForm testidPrefix="collab-enquiry" />
          </Reveal>
        </div>
      </div>
    </main>
  );
}
